/**
 * This file defines the organization context for the application.
 * It serves as a high-level context layer, scoped at the organization ('org') level.
 * 
 * Please be judicious when adding new state here—only include state that truly requires
 * broad access or open pollination across many components at the organization level.
 * This ensures the context remains performant, maintainable, and relevant.
 */

import { createContext, useContext } from "react";
import { ORG_CONTEXT_ACTION_TYPES } from "./org-context-reducer";

export const OrgContext = createContext(null)
export const OrgHoverContext = createContext(null)
export const OrgContextDispatch = createContext(null)

export const useOrgContext = () => {
  return useContext(OrgContext)
}

export const useOrgHoverContext = () => {
  return useContext(OrgHoverContext)
}

export const useOrgContextDispatch = () => {
  return useContext(OrgContextDispatch)
}

// Dispatch Helpers

export const setActiveOrgs = ({ activeOrgs }) => {
  return {
    type: ORG_CONTEXT_ACTION_TYPES.SET_ACTIVE_ORGS,
    activeOrgs,
  }
}

export const setLastFarmId = ({ farmId }) => {
  return {
    type: ORG_CONTEXT_ACTION_TYPES.SET_LAST_FARM_ID,
    farmId,
  }
}

export const setLastSeasonId = ({ seasonId }) => {
  return {
    type: ORG_CONTEXT_ACTION_TYPES.SET_LAST_SEASON_ID,
    seasonId,
  }
}

export const bumpSeasonListKey = () => ({
  type: ORG_CONTEXT_ACTION_TYPES.BUMP_SEASON_LIST_KEY,
})

export const setHoveredOrg = ({ hoveredOrg }) => {
  return {
    type: ORG_CONTEXT_ACTION_TYPES.SET_HOVERED_ORG,
    hoveredOrg,
  }
}

export const setHoveredTask = ({ hoveredTask }) => {
  return {
    type: ORG_CONTEXT_ACTION_TYPES.SET_HOVERED_TASK,
    hoveredTask,
  }
}

export const setHoveredTaskGap = ({ hoveredTaskGap }) => {
  return {
    type: ORG_CONTEXT_ACTION_TYPES.SET_HOVERED_TASK_GAP,
    hoveredTaskGap,
  }
}
